import { useEffect, useState } from 'react';

/**
 * Lightweight online/offline detector.
 * Returns `true` when the browser believes it's online. Listens to both
 * `online`/`offline` events AND falls back to `navigator.onLine` polling
 * because some Android Chrome builds miss the `online` event after a
 * cellular ↔ Wi-Fi handover.
 */
export default function useOnlineStatus() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener('online', onUp);
    window.addEventListener('offline', onDown);
    // Defensive poll every 8s — covers handover edge cases.
    const t = setInterval(() => setOnline(navigator.onLine), 8000);
    return () => {
      window.removeEventListener('online', onUp);
      window.removeEventListener('offline', onDown);
      clearInterval(t);
    };
  }, []);

  return online;
}
